import script from "./BrandRejectory.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandRejectory.vue?vue&type=script&setup=true&lang=js"

import "./BrandRejectory.vue?vue&type=style&index=0&id=d1f19120&scoped=true&lang=scss"

import exportComponent from "/Users/kadir.aslan/Projects/Repositories/Personal/kadiraslan-de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1f19120"]])

export default __exports__